import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { benefitProps } from "../types/attribute/benefit";
import { api } from "../services/api.service";

export const fetchBenefits = createAsyncThunk<benefitProps[]>("fetch/benefits", async () => {
  const data = await api.attribute.benefit.getAll();
  return data as benefitProps[];
});

interface benefitsState {
  benefits: benefitProps[];
  benefit: null | benefitProps;
  loading: boolean;
  error: null | string;
}

const initialState: benefitsState = {
  benefits: [],
  benefit: null,
  loading: false,
  error: null,
};

export const benefitsSlice = createSlice({
  name: "benefits",
  initialState,
  reducers: {
    addBenefit: (state, action: PayloadAction<benefitProps>) => {
      state.benefits.push(action.payload);
    },
    removeBenefit: (state, action: PayloadAction<{ id: number }>) => {
      state.benefits = state.benefits.filter(
        (benefit) => benefit.id !== action.payload.id
      );
    },
    updateBenefit: (state, action: PayloadAction<benefitProps>) => {
      state.benefits = state.benefits.map((benefit) =>
        benefit.id === action.payload.id ? action.payload : benefit
      );
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchBenefits.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchBenefits.fulfilled, (state, action) => {
        state.error = null;
        state.loading = false;
        state.benefits = action.payload;
      })
      .addCase(fetchBenefits.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Something went wrong";
      });
  },
});

export const { addBenefit, removeBenefit, updateBenefit } =
  benefitsSlice.actions;

export default benefitsSlice.reducer;
